export default __webpack_public_path__ + "ac09fe9c6bc9820bbdaf2b1bf5d93cb6.png";